import React, { useState } from 'react'
import { node } from 'prop-types'

import { Tabs, Tab } from '@material-ui/core'

import TabText from './TabbedContainer.style'

function TabbedContainer({ children }) {
  const tabList = React.Children.toArray(children)

  const [tabIndex, setTabIndex] = useState(0)

  const handleTabChange = (_, currentIndex) => {
    setTabIndex(currentIndex)
  }

  return (
    <>
      <Tabs
        value={tabIndex}
        textColor="secondary"
        indicatorColor="secondary"
        onChange={handleTabChange}
        variant="fullWidth"
      >
        {tabList.map(({ props: { label } }) => (
          <Tab key={label} label={<TabText>{label}</TabText>} />
        ))}
      </Tabs>

      {tabList[tabIndex]}
    </>
  )
}

TabbedContainer.propTypes = {
  children: node.isRequired,
}

export default TabbedContainer
